import { Box, LoadingOverlay } from '@mantine/core';
import React from 'react';

import { DeviceType, useDeviceModelFiles } from '@portals/api/organizations';
import { FileTypeIcon } from '@portals/core';
import { SmartTable } from '@portals/table';
import {
  OrganizationFileResponseType,
  TableColumn,
  TableFilterTypeEnum,
} from '@portals/types';

import { OwnerBadge } from './OwnerBadge';
import { FileDetailsPanel } from '../../../../components/Files/FileDetailsPanel';

interface DeviceModelFileInfosProps {
  device: DeviceType;
}

export function DeviceModelFileInfos({ device }: DeviceModelFileInfosProps) {
  const modelId = device.partner.type_id;
  const files = useDeviceModelFiles(modelId);

  if (files.isLoading || !files.data) {
    return <LoadingOverlay visible />;
  }

  const columns: TableColumn<OrganizationFileResponseType>[] = [
    {
      dataField: 'type',
      text: '',
      maxWidth: 72,
      minWidth: 72,
      formatter: (_, { url }) => <FileTypeIcon fileUrl={url} width={33} />,
    },
    {
      dataField: 'name',
      text: 'Name',
      filter: { type: TableFilterTypeEnum.Text },
    },
    {
      dataField: 'partner',
      text: 'Owner',
      filter: {
        type: TableFilterTypeEnum.Select,
        options: {
          true: 'Manufacturer',
          false: 'Organization',
        },
      },
      formatter: (cell, { partner }) => <OwnerBadge isPartnerFile={partner} />,
    },
    {
      dataField: 'desc',
      text: 'Description',
    },
    {
      dataField: 'version',
      text: 'Version',
    },
  ];

  return (
    <Box sx={{ height: '100%' }} py="md">
      <SmartTable<OrganizationFileResponseType>
        keyField="id"
        columns={columns}
        data={files.data}
        name="organizations.overview.device.files"
        noSort
        noHeader
        noFilters
        isUrlSyncEnabled={false}
        noDataIndication={{ title: 'No files' }}
        defaultSorted={[{ id: 'name', desc: false }]}
        detailsPanel={{
          type: 'inner',
          renderer: ({ row, onClose }) => (
            <FileDetailsPanel
              file={row.original}
              onClose={onClose}
              device={device}
            />
          ),
        }}
      />
    </Box>
  );
}
